import KpsEditor from "../editor/KpsEditor";
import { Trans } from "react-i18next";
import RadioGroup from "@material-ui/core/RadioGroup";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "@material-ui/core/Button";
import Radio from "@material-ui/core/Radio";
import DialogContent from "@material-ui/core/DialogContent";
import { containsScriptOrSVG, containsBadCharacter } from "../../utils/ContentChecker";
import {
  setGlobalAlert
} from "../../redux/actions/universalActions";
import { connect } from "react-redux";
const styles = (theme) => ({
  test: {
    height: "300px",
  },
  title: {
    fontSize: "20px",
    paddingBottom: "20px",
  },
  buttons: {
    padding: "8px 8px 8px 24px",
  },
  page: {
    padding: "24px",
  },
});
class CreateAttachment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titleText: "Add attachment",
      radioValue: "above",
      text: "",
      attachmentIds: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.editorChange = this.editorChange.bind(this);
    this.saveAttachment = this.saveAttachment.bind(this);
  }
  render() {
    const notAttachment = this.props.notAttachment;
    let radioButtons = null;
    if (!notAttachment) {
      radioButtons = (
        <RadioGroup value={this.state.radioValue} onChange={this.handleChange}>
          <FormControlLabel
            value="above"
            control={<Radio color="primary" />}
            label="Above list"
            labelPlacement="start"
          />
          <FormControlLabel
            value="below"
            control={<Radio color="primary" />}
            label="Below list"
            labelPlacement="start"
          />
        </RadioGroup>
      );
    }
    return (
      <>
        <DialogTitle id="api-dialog-title"> {this.state.titleText}</DialogTitle>
        <DialogContent>
          <KpsEditor
            updateUploadArray={this.updateUploadArray}
            onChange={this.editorChange}
            ref="section"
            newUploadId={this.newUploadId}
          />
          {radioButtons}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.close} color="primary">
            <Trans i18nKey="global_cancel" />
          </Button>
          <Button onClick={this.saveAttachment} color="primary">
            <Trans i18nKey="global_save" />
          </Button>
        </DialogActions>
      </>
    );
  }
  updateUploadArray = (array) => {
    this.setState({ attachmentIds: array });
  };
  newUploadId = (response) => {
    let attachments = this.state.attachmentIds.splice(0);
    attachments.push(Number(response));
    this.setState({ attachmentIds: attachments });
  };
  editorChange = (event) => {
    this.setState({ text: event });
  };
  handleChange = (event) => {
    this.setState({ radioValue: event.target.value });
  };
  saveAttachment = () => {
    if (containsScriptOrSVG([this.state.text])) {
      this.props.setGlobalAlert({type:"error", message:"harmful_content", open:true})
      return;
    } else if (containsBadCharacter([this.state.text])){
      this.props.setGlobalAlert({type:"error", message:"unusable_character", open:true})
      return;
    }
    let attachment = {};
    attachment.text = this.state.text;
    attachment.top = this.state.radioValue === "above" ? true : false;
    attachment.attachmentIds = this.state.attachmentIds;
    this.props.onSaveAttachment(attachment, this.state.attachmentIds);
  };
}
const mapDispatchToProps = {
  setGlobalAlert,
};
export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(CreateAttachment));
